import useWindowDimensions from "@/hooks/useWindowDimensions";
import React, { cloneElement, useEffect, useState } from "react";
import { FixedSizeList as List } from "react-window";
import VillaItem from "./VillaItem";

const HorizontalVillaList = ({ vitrins, children }) => {
  const width = useWindowDimensions();
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  // Calculate item width including gap
  const getItemWidth = () => {
    if (!width) return 306; // Default width when undefined
    if (width >= 640) return 320; // sm: full width + gap
    if (width >= 375) return 306; // ml: 300px + 16px gap
    return 306; // w: 290px + 16px gap
  };

  // Calculate container width
  const getContainerWidth = () => {
    if (!width) return 375; // Default fallback width
    return width;
  };

  const itemWidth = getItemWidth();
  const containerWidth = getContainerWidth();
  const listHeight = 400; // Adjust based on your VillaCard height

  // Don't render react-window until component is mounted and width is available
  if (!mounted || !width) {
    return (
      <div className="flex gap-4 overflow-x-auto flex-nowrap">
        {vitrins?.map((villa) => (
          <div
            className="flex-shrink-0 sm:w-full ml:w-[300px] w-[290px]"
            key={villa.id}
          >
            {cloneElement(children, {
              villa,
            })}
          </div>
        ))}
      </div>
    );
  }

  return (
    <List
      height={listHeight}
      width={containerWidth}
      itemCount={vitrins?.length || 0}
      itemSize={itemWidth}
      itemData={vitrins}
      layout="horizontal"
      className="overflow-x-auto"
      style={{
        overflowY: "hidden",
      }}
    >
      {VillaItem}
    </List>
  );
};

export default HorizontalVillaList;
